import { List } from 'immutable';
import { providerConstants } from '../constants';

export function providers(state = {}, action) {
  switch (action.type) {
    case providerConstants.PROVIDER_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case providerConstants.PROVIDER_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case providerConstants.PROVIDER_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };
    case providerConstants.PROVIDER_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case providerConstants.PROVIDER_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case providerConstants.PROVIDER_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case providerConstants.PROVIDER_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case providerConstants.PROVIDER_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const providerIndex = state.items.findIndex(val => val.id == action.response.id);

      if (providerIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(providerIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case providerConstants.PROVIDER_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case providerConstants.PROVIDER_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case providerConstants.PROVIDER_DELETE_SUCCESS: {
      const { providerId } = action;

      if (!state.items) {
        return state;
      }

      const providerIndex = state.items.findIndex(val => val.id == providerId);

      if (providerIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(providerIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case providerConstants.PROVIDER_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case providerConstants.PROVIDER_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
